module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tc-root"
  }, [(!_vm.points.length) ? _c('div', {
    staticClass: "tc-blank"
  }, [_vm._v("No nudges were sent on these days.")]) : _c('div', {
    staticClass: "tc-plot",
    on: {
      "mouseleave": function($event) {
        _vm.hover = null
      }
    }
  }, [_c('svg', {
    staticClass: "tc-svg",
    attrs: {
      "viewBox": ("0 0 " + _vm.width + " " + _vm.height),
      "role": "img",
      "aria-label": _vm.ariaLabel,
      "preserveAspectRatio": "none"
    }
  }, [_c('g', {
    staticClass: "tc-grid"
  }, _vm._l((_vm.ticks), function(tick) {
    return _c('line', {
      key: ("g" + tick),
      attrs: {
        "x1": 0,
        "x2": _vm.width,
        "y1": _vm.yOf(tick),
        "y2": _vm.yOf(tick)
      }
    })
  }), 0), _vm._v(" "), _c('g', [_vm._l((_vm.points), function(point, i) {
    return _c('rect', {
      key: ("h" + (point.day)),
      staticClass: "tc-hit",
      attrs: {
        "x": _vm.xOf(i),
        "y": 0,
        "width": _vm.bandWidth,
        "height": _vm.height
      },
      on: {
        "mouseenter": function($event) {
          _vm.hover = i
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.points), function(point, i) {
    return _c('g', {
      key: point.day,
      class: {
        'is-dim': _vm.hover !== null && _vm.hover !== i
      }
    }, [_c('rect', {
      staticClass: "tc-bar",
      attrs: {
        "x": _vm.xOf(i) + _vm.gap,
        "y": _vm.yOf(point.rate),
        "width": Math.max(_vm.barWidth, 1),
        "height": Math.max(_vm.plotHeight - (_vm.yOf(point.rate) - _vm.padTop), 2),
        "rx": _vm.radiusFor(point.rate)
      }
    }), _vm._v(" "), _c('rect', {
      staticClass: "tc-bar",
      attrs: {
        "x": _vm.xOf(i) + _vm.gap,
        "y": Math.max(_vm.yOf(point.rate) + _vm.radiusFor(point.rate), _vm.yOf(point.rate)),
        "width": Math.max(_vm.barWidth, 1),
        "height": Math.max(_vm.plotHeight - (_vm.yOf(point.rate) - _vm.padTop) - _vm.radiusFor(point.rate), 0)
      }
    })])
  })], 2), _vm._v(" "), (_vm.peakIndex !== null) ? _c('text', {
    staticClass: "tc-peak",
    attrs: {
      "x": _vm.xOf(_vm.peakIndex) + (_vm.bandWidth / 2),
      "y": Math.max(_vm.yOf(_vm.points[_vm.peakIndex].rate) - 7, 11),
      "text-anchor": "middle"
    }
  }, [_vm._v(_vm._s(_vm.points[_vm.peakIndex].rate) + "%")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tc-yaxis",
    attrs: {
      "aria-hidden": "true"
    }
  }, _vm._l((_vm.ticks), function(tick) {
    return _c('span', {
      key: ("y" + tick),
      style: ({
        top: ((((_vm.yOf(tick) / _vm.height) * 100)) + "%")
      })
    }, [_vm._v(_vm._s(tick) + "%")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tc-xaxis"
  }, _vm._l((_vm.points), function(point, i) {
    return _c('span', {
      key: ("x" + (point.day)),
      class: {
        'is-active': _vm.hover === i
      },
      style: ({
        width: ((100 / _vm.points.length) + "%")
      })
    }, [_vm._v(_vm._s(_vm.showLabel(i) ? _vm.shortDay(point.day) : ''))])
  }), 0), _vm._v(" "), (_vm.hover !== null) ? _c('div', {
    staticClass: "tc-tip",
    style: ({
      left: (_vm.tipLeft + "%"),
      transform: ("translateX(" + _vm.tipShift + ")")
    })
  }, [_c('div', {
    staticClass: "tc-tip-day"
  }, [_vm._v(_vm._s(_vm.longDay(_vm.points[_vm.hover].day)))]), _vm._v(" "), _c('div', {
    staticClass: "tc-tip-row"
  }, [_c('span', [_vm._v("Reply rate")]), _c('strong', [_vm._v(_vm._s(_vm.points[_vm.hover].rate) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "tc-tip-row"
  }, [_c('span', [_vm._v("Delivered")]), _c('strong', [_vm._v(_vm._s(_vm.points[_vm.hover].delivered.toLocaleString()))])]), _vm._v(" "), _c('div', {
    staticClass: "tc-tip-row"
  }, [_c('span', [_vm._v("Replies")]), _c('strong', [_vm._v(_vm._s(_vm.points[_vm.hover].responded.toLocaleString()))])])]) : _vm._e()]), _vm._v(" "), (_vm.points.length) ? _c('details', {
    staticClass: "tc-table"
  }, [_c('summary', [_vm._v("View as table")]), _vm._v(" "), _c('table', [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.points), function(point) {
    return _c('tr', {
      key: ("t" + (point.day))
    }, [_c('td', [_vm._v(_vm._s(_vm.longDay(point.day)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(point.delivered.toLocaleString()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(point.responded.toLocaleString()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(point.rate) + "%")])])
  }), 0)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Day")]), _c('th', [_vm._v("Delivered")]), _c('th', [_vm._v("Replies")]), _c('th', [_vm._v("Reply rate")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-ea669ca8","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nudge-console/analytics/TrendChart.vue
// module id = BRvo
// module chunks = 1